/**
 * Person type created by karora on 24/06/17.
 */

export class Person {
  id: number;
  guid: string;
  name: string;
  location: string;
  email: string;
  phone: string;
  active: boolean;
  score: number;
  person_type_id: number;
  response_count: number;

  public get person_type_description(): string {
    switch (this.person_type_id) {
      case 2: return "Reporter"; break;
      default: return "Public"; break;
    }
  }

}
